/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BlogManagerCreateTagResponse } from "./BlogManagerCreateTagResponse";

export type BlogManagerCreateTagResponseApiRespoonse = {
  data?: BlogManagerCreateTagResponse;
  status?: BlogManagerCreateTagResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace BlogManagerCreateTagResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
